/* eslint-disable import/no-mutable-exports */
import { injectRouter } from '@lumapps/router/routers';

function setRouter($state) {
    injectRouter({ go: $state.go });
}

export { setRouter };
